<template>
    <div class="enps-table-toolbar">
        <VSearchField
            class="enps-table-toolbar__search"
            :placeholder="placeholder"
            @input="$emit('input', $event)"
        ></VSearchField>

        <!-- Чекбокс — только там, где у строк вообще есть понятие «активен/деактивирован»
             (исполнители, авторы). У категорий такого поля нет, и withInactiveFilter туда просто
             не передаётся — чекбокс не рендерится, а не рендерится отключённым. -->
        <InputCheckbox
            v-if="withInactiveFilter"
            class="enps-table-toolbar__checkbox"
            :value="hideInactive"
            @input="$emit('toggle-inactive', $event)"
        >
            Скрыть неактивных
        </InputCheckbox>

        <!-- «Показано N из M» — только когда фильтры реально что-то прячут. При visibleCount ===
             totalCount счётчик не несёт информации и просто шумит рядом с полем поиска. -->
        <span v-if="visibleCount < totalCount" class="enps-table-toolbar__count">
            Показано {{ visibleCount }} из {{ totalCount }}
        </span>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import VSearchField from '@/views/components/VInput/VSearchField.vue';
import InputCheckbox from '@/views/components/VCheckbox/InputCheckbox.vue';

// Общий тулбар поиска/фильтра для таблиц ENPS-дашборда (исполнители, авторы, категории).
// Компонент не хранит текст поиска сам — VSearchField уже неуправляемый и держит строку у себя,
// дублировать её здесь незачем. Дебаунса нет НАМЕРЕННО: фильтрация чисто клиентская
// (Array.filter по уже загруженным данным в вычисляемом свойстве родителя), а не запрос к
// серверу — задержка имеет смысл только когда input триггерит сеть.
@Component({
    components: {
        VSearchField,
        InputCheckbox,
    },
})
class EnpsTableToolbar extends Vue {
    @Prop({ type: String, default: 'Поиск' })
    placeholder;

    @Prop({ type: Boolean, default: false })
    withInactiveFilter;

    @Prop({ type: Boolean, default: false })
    hideInactive;

    @Prop({ type: Number, required: true })
    visibleCount;

    @Prop({ type: Number, required: true })
    totalCount;
}

export default EnpsTableToolbar;
</script>
<style lang="scss">
.enps-table-toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 15px;
    border-bottom: 1px solid #e4eaef;

    &__search {
        flex: 1;
        min-width: 0;
        max-width: 320px;
    }

    &__checkbox {
        flex-shrink: 0;
    }

    &__count {
        flex-shrink: 0;
        margin-left: auto;
        color: #767676;
        font-size: 0.8125rem;
        white-space: nowrap;
    }
}
</style>
